export default {
  getLinks: (state) => state.links,
  getDownloads: (state) => state.downloads,
  getPagination: (state) => state.pagination,
  getBackupLimit: (state) => state.backupLimit,
  hasBackupProcessing: (state) =>
    state.downloads.some((download) => download.status === 'processing'),
};
